var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333252 15C0.333252 13.9645 1.17272 13.125 2.20825 13.125H28.4583C29.4938 13.125 30.3333 13.9645 30.3333 15C30.3333 16.0355 29.4938 16.875 28.4583 16.875H2.20825C1.17272 16.875 0.333252 16.0355 0.333252 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6591 0.549175C17.3913 1.28141 17.3913 2.46859 16.6591 3.20083L4.8599 15L16.6591 26.7992C17.3913 27.5314 17.3913 28.7186 16.6591 29.4508C15.9268 30.1831 14.7397 30.1831 14.0074 29.4508L0.882427 16.3258C0.150194 15.5936 0.150194 14.4064 0.882427 13.6742L14.0074 0.549175C14.7397 -0.183058 15.9268 -0.183058 16.6591 0.549175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7bb50f73ab5b03be431048fbc9d9f9c4.svg";
export { ForwardRef as ReactComponent };